// removed by extract-text-webpack-plugin
module.exports = {"Loader":"spinner__Loader__3RaNW","load8":"spinner__load8__3iDVm","small":"spinner__small__wuO8M","errorBox":"spinner__errorBox__i415R","errorSubMessage":"spinner__errorSubMessage__2eSNk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/spinner.css
// module id = 1609
// module chunks = 0